import React, { useState, useRef, useCallback } from 'react';
import DOMPurify from 'dompurify';
import SearchBox from './SearchBox';
export default function RefinementList({ refinementList, refinementListSettings, }) {
    const { className, classNames, translations, showMore, searchable, searchablePlaceholder, } = refinementListSettings;
    const { items, canToggleShowMore, canRefine, isShowingMore, isFromSearch, refine, searchForItems, toggleShowMore, } = refinementList;
    const rootClass = [
        'ais-RefinementList',
        classNames === null || classNames === void 0 ? void 0 : classNames.root,
        !canRefine ? 'ais-RefinementList--noRefinement' : '',
        !canRefine ? 'classNames?.noRefinementRoot' : '',
        className,
    ].filter(Boolean).join(' ');
    const searchBoxClass = [
        'ais-RefinementList-searchBox',
        classNames === null || classNames === void 0 ? void 0 : classNames.searchBox,
    ].filter(Boolean).join(' ');
    const noResultClass = [
        'ais-RefinementList-noResults',
        classNames === null || classNames === void 0 ? void 0 : classNames.noResults,
    ].filter(Boolean).join(' ');
    const listClass = [
        'ais-RefinementList-list',
        classNames === null || classNames === void 0 ? void 0 : classNames.list,
    ].filter(Boolean).join(' ');
    const showMoreClass = [
        'ais-RefinementList-showMore',
        classNames === null || classNames === void 0 ? void 0 : classNames.showMore,
        !canToggleShowMore ? 'ais-RefinementList-showMore--disabled' : '',
        !canToggleShowMore ? classNames === null || classNames === void 0 ? void 0 : classNames.disabledShowMore : '',
    ].filter(Boolean).join(' ');
    const noResults = searchable
        && isFromSearch
        && items.length === 0
        && (translations === null || translations === void 0 ? void 0 : translations.noResultsText);
    const [inputValue, setInputValue] = useState('');
    const inputRef = useRef(null);
    const setQuery = useCallback((newQuery, compositionComplete = true) => {
        setInputValue(newQuery);
        if (compositionComplete) {
            searchForItems(newQuery);
        }
    }, [searchForItems]);
    const onChange = useCallback((event) => {
        const compositionComplete = event.type === 'compositionend'
            || !event.nativeEvent.isComposing;
        setQuery(event.currentTarget.value, compositionComplete);
    }, [setQuery]);
    const onSubmit = useCallback(() => {
        var _a;
        if (items.length > 0) {
            refine(((_a = items[0]) === null || _a === void 0 ? void 0 : _a.value) || '');
            setQuery('');
        }
    }, [items, refine, setQuery]);
    const onReset = useCallback(() => {
        setQuery('');
    }, [setQuery]);
    return (React.createElement("div", { className: rootClass },
        searchable && (React.createElement("div", { className: searchBoxClass },
            React.createElement(SearchBox, { inputRef: inputRef, placeholder: searchablePlaceholder || '', translations: {
                    submitButtonTitle: ((translations === null || translations === void 0 ? void 0 : translations.submitButtonTitle) || ''),
                    resetButtonTitle: ((translations === null || translations === void 0 ? void 0 : translations.resetButtonTitle) || ''),
                }, value: inputValue, onChange: onChange, onSubmit: onSubmit, onReset: onReset }))),
        noResults ? (React.createElement("div", { className: noResultClass }, translations === null || translations === void 0 ? void 0 : translations.noResultsText)) : (React.createElement("ul", { className: listClass }, items.map((item) => {
            const itemClass = [
                'ais-RefinementList-item',
                classNames === null || classNames === void 0 ? void 0 : classNames.item,
                item.isRefined ? 'ais-RefinementList-item--selected' : '',
                item.isRefined ? classNames === null || classNames === void 0 ? void 0 : classNames.selectedItem : '',
            ].filter(Boolean).join(' ');
            const labelClass = [
                'ais-RefinementList-label',
                classNames === null || classNames === void 0 ? void 0 : classNames.label,
            ].filter(Boolean).join(' ');
            const inputClass = [
                'ais-RefinementList-checkbox',
                classNames === null || classNames === void 0 ? void 0 : classNames.checkbox,
            ].filter(Boolean).join(' ');
            const labelTextClass = [
                'ais-RefinementList-labelText',
                classNames === null || classNames === void 0 ? void 0 : classNames.labelText,
            ].filter(Boolean).join(' ');
            const countClass = [
                'ais-RefinementList-count',
                classNames === null || classNames === void 0 ? void 0 : classNames.count,
            ].filter(Boolean).join(' ');
            return (React.createElement("li", { key: item.value, className: itemClass },
                React.createElement("label", { className: labelClass },
                    React.createElement("input", { checked: item.isRefined, className: inputClass, type: "checkbox", value: item.value, onChange: () => {
                            refine(item.value);
                            setQuery('');
                        } }),
                    React.createElement("span", { className: labelTextClass, 
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML: {
                            __html: DOMPurify.sanitize(item.label),
                        } }),
                    React.createElement("span", { className: countClass }, item.count))));
        }))),
        showMore && (React.createElement("button", { className: showMoreClass, disabled: !canToggleShowMore, type: "button", onClick: toggleShowMore }, (translations === null || translations === void 0 ? void 0 : translations.showMoreButtonText)
            ? translations.showMoreButtonText({ isShowingMore })
            : ''))));
}
